import { Eye, MaskSad, Pencil, User } from "phosphor-react";
import React, { useRef } from "react";
import Button from "~/admin/components/Button";
import Card from "~/admin/components/Card";
import Pagination from "~/admin/components/Pagination";
import SearchInput from "~/admin/components/SearchInput";
import Table from "~/admin/components/Table";
import Td from "~/admin/components/Td";
import Th from "~/admin/components/Th";
import Tr from "~/admin/components/Tr";
import Notifications from "~/admin/services/Notifications";
import CreateAdminModal from "./components/CreateAdminModal";
import UpdateAdminModal from "./components/UpdateAdminModal";

export default function AdminsTab({ admins, onSearch, onPaginate }) {
  const createAdminModal = useRef();
  const updateAdminModal = useRef();

  const onCreated = async (id) => {
    Notifications.success("Administrateur créé avec succès");
    onSearch();
  };

  const onUpdated = async (id) => {
    Notifications.success("Administrateur modifié avec succès");
    onSearch();
  };

  return (
    <>
      <Button
        color="tertiary"
        size="s"
        className="mb-4"
        icon={<User />}
        onClick={() => createAdminModal.current?.open()}
      >
        Ajouter un administrateur
      </Button>
      {admins.items?.length > 0 ? (
        <Card>
          <div className="md:max-w-[300px] mb-2">
            <SearchInput
              onSearch={onSearch}
              placeholder="Rechercher un administrateur"
            />
          </div>
          <Table>
            <thead>
              <Tr>
                <Th>Nom</Th>
                <Th>Prénom</Th>
                <Th>Email</Th>
                <Th></Th>
              </Tr>
            </thead>
            <tbody>
              {admins.items.map((admin) => {
                return (
                  <Tr key={admin.id}>
                    <Td>{admin.lastName}</Td>
                    <Td>{admin.firstName}</Td>
                    <Td>{admin.email}</Td>
                    <Td isActions>
                      <Pencil
                        className="cursor-pointer hover:text-gray-400"
                        size={24}
                        onClick={() => {
                          updateAdminModal?.current?.open(admin.id);
                        }}
                      />
                      <Eye
                        className="cursor-pointer hover:text-gray-400"
                        size={24}
                        onClick={() => {}}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <div className="pt-4 text-center">
            <Pagination
              lastPage={admins.lastPage}
              currentPage={admins.currentPage}
              onPaginate={onPaginate}
            />
          </div>
        </Card>
      ) : (
        <div className="px-4 py-2 bg-blue-300 text-blue-700 w-fit rounded-md mx-auto flex space-x-4 items-center">
          <div>
            <MaskSad />
          </div>
          <div>Il n'y a aucun administrateur pour l'instant !</div>
        </div>
      )}
      <CreateAdminModal ref={createAdminModal} onSubmitted={onCreated} />
      <UpdateAdminModal ref={updateAdminModal} onSubmitted={onUpdated} />
    </>
  );
}
